import type { ApiError } from '@/shared/api';

const FALLBACK = 'Die Änderung am Wohnungsverbund wurde nicht gespeichert. Bitte erneut versuchen.';

// Diese Ablehnungen tragen einen deutschen Satz des Servers, der für sich steht.
const OWN_WORDS = new Set([
  'flat_family_other_object',
  'flat_family_archived',
  'flat_family_room_has_rooms',
  'flat_family_whole_flat_is_room',
  'flat_family_room_already_linked',
  'flat_family_same_apartment',
  'property_not_found',
  'property_distribution_topology_changed',
]);

/** Der Satz, der unter der Aktion stehen bleibt — nie ein interner Text oder ein falsches „nein“. */
export function flatFamilyFailureMessage(problem: ApiError): string {
  if (problem.status === 0) {
    return 'Keine Antwort vom Server – ob gespeichert wurde, ist offen. Der Stand wird neu geladen.';
  }
  if (problem.status === 403) return 'Dafür fehlt Ihnen die Berechtigung.';
  if (OWN_WORDS.has(problem.title) && problem.detail) return problem.detail;
  return FALLBACK;
}
